import { motion } from "motion/react";
import { cn } from "@babackapp/customer-ui/lib/utils";
import { cva, VariantProps } from "class-variance-authority";

const widgetPageVariants = cva(
  "flex flex-col gap-10 compact:gap-4 w-full flex-1 min-h-0 pt-20",
  {
    variants: {
      variant: {
        // The scroll container's bottom padding sits behind this box, which
        // `min-h-0` keeps as tall as the viewport while content overflows it.
        // A trailing spacer overflows with the content, leaving room under the
        // last button once scrolled to the end. The spacer is a flex item, so
        // the negative margin cancels the page gap: 24px in all, not 24 + gap.
        default:
          "after:content-[''] after:block after:shrink-0 after:h-6 after:-mt-10 compact:after:-mt-4",
        // Plain `justify-center` makes the overflow above the centered content
        // unreachable by scroll: on a short viewport (12" laptop, most phones)
        // the logo sits above the visible area with no way to scroll up to it.
        // `-safe` falls back to start-alignment once the content no longer fits,
        // which keeps everything scrollable into view instead.
        centered: "justify-center-safe flex h-full -pt-24",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export function WidgetPage({
  className,
  variant,
  ...props
}: React.ComponentProps<typeof motion.div> &
  VariantProps<typeof widgetPageVariants>) {
  return (
    <motion.div
      className={cn(widgetPageVariants({ variant, className }), className)}
      {...props}
    />
  );
}
